// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-index-productDay-jzqga{width:100%}.pages-index-productDayWrapper-wugsi.pages-index-mobile-bcbvq{margin-left:-12px;margin-right:-12px}.pages-index-productsBlock3-qljgz{margin-bottom:24px}.pages-index-productsBlock3-qljgz:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDay": "pages-index-productDay-jzqga",
	"productDayWrapper": "pages-index-productDayWrapper-wugsi",
	"mobile": "pages-index-mobile-bcbvq",
	"productsBlock3": "pages-index-productsBlock3-qljgz"
};
module.exports = ___CSS_LOADER_EXPORT___;
